import axiosInstance, { endpoints } from 'src/lib/axios';

// ----------------------------------------------------------------------

/**
 * localStorage key holding a pending invite id. Set when a logged-out visitor opens an
 * invite link, so the join can be completed after they log in or register (the register
 * flow does not preserve returnTo). Consumed by InbjudanAutoAccept in the dashboard layout.
 */
export const INBJUDAN_VÄNTANDE_KEY = 'inbjudan-vantande-id';

export type InbjudanMottagareStatus = 'SKICKAD' | 'ACCEPTERAD' | 'MISSLYCKAD';

export interface IInbjudanMottagare {
  epost: string;
  status: InbjudanMottagareStatus;
  skickadTidpunkt?: string;
  accepteradTidpunkt?: string;
}

export interface IInbjudan {
  inbjudanId: string;
  orgId: string;
  aktiv: boolean;
  mottagare: IInbjudanMottagare[];
}

export interface IInbjudanInfo {
  inbjudanId: string;
  orgId: string;
  organisationsNamn: string;
  aktiv: boolean;
}

/** Admin: get-or-create the org's reusable invite link + its email recipient log. */
export function hämtaInbjudan(orgId: string): Promise<IInbjudan> {
  return axiosInstance.get(endpoints.inbjudan.organisation(orgId)).then((r) => r.data);
}

/** Admin: email the reusable invite link to one or more addresses. */
export function bjudInMedEpost(orgId: string, epostadresser: string[]): Promise<IInbjudan> {
  return axiosInstance
    .post(endpoints.inbjudan.epost(orgId), { epostadresser })
    .then((r) => r.data);
}

/** Public: non-sensitive landing info (organisation name) for an invite link. */
export function hämtaInbjudanInfo(inbjudanId: string): Promise<IInbjudanInfo> {
  return axiosInstance.get(endpoints.inbjudan.info(inbjudanId)).then((r) => r.data);
}

/** Authenticated: the current user accepts the invite and joins the organisation. */
export function accepteraInbjudan(inbjudanId: string): Promise<void> {
  return axiosInstance.post(endpoints.inbjudan.acceptera(inbjudanId)).then(() => undefined);
}
